<template>
  <el-select
    :value="selectValue"
    :disabled="disabled"
    :size="size"
    :clearable="clearable"
    filterable
    remote
    reserve-keyword
    :loading="loading"
    :placeholder="placeholder"
    popper-class="ai-account-select-dropdown"
    style="width: 100%"
    @input="handleInput"
    @change="handleChange"
    @visible-change="handleVisibleChange"
    :remote-method="remoteSearch"
  >
    <el-option
      v-for="item in options"
      :key="normalizeId(item.id)"
      :label="formatLabel(item)"
      :value="normalizeId(item.id)"
    >
      <div class="account-option">
        <div class="account-option__avatar">
          <img
            v-if="item.avatar"
            :src="item.avatar"
            alt=""
            @error="handleAvatarError(item)"
          >
          <span v-else>{{ avatarText(item) }}</span>
        </div>
        <div class="account-option__body">
          <div class="account-option__main">
            <span class="account-option__name">{{ item.nickname || '未设置昵称' }}</span>
            <span class="account-option__id">ID: {{ item.id }}</span>
          </div>
          <div class="account-option__sub">
            <span v-if="item.mobile">{{ item.mobile }}</span>
            <span v-if="item.specificCode">靓号: {{ item.specificCode }}</span>
          </div>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { getUser } from '@/api/demo/user'

export default {
  name: 'AiAccountSelector',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: '搜索账户ID/昵称/手机号'
    },
    size: {
      type: String,
      default: 'small'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      loading: false,
      options: [],
      searchTimer: null,
      requestSeq: 0
    }
  },
  computed: {
    selectValue () {
      return this.normalizeId(this.value)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.loadSelected(val)
      }
    }
  },
  beforeDestroy () {
    if (this.searchTimer) clearTimeout(this.searchTimer)
  },
  methods: {
    normalizeId (value) {
      if (value === undefined || value === null) return ''
      return String(value)
    },
    formatLabel (item) {
      if (!item) return ''
      const parts = [item.nickname || '未设置昵称', `ID:${item.id}`]
      if (item.mobile) parts.push(item.mobile)
      return parts.join(' / ')
    },
    avatarText (item) {
      const name = (item && item.nickname) || ''
      return name ? name.slice(0, 1) : '账'
    },
    handleAvatarError (item) {
      this.$set(item, 'avatar', '')
    },
    normalizeRecords (res) {
      return (res && res.records) || []
    },
    mergeOptions (records) {
      const map = {}
      const merged = []
      const source = [...this.options, ...records]
      source.forEach(item => {
        const id = this.normalizeId(item && item.id)
        if (!id || map[id]) return
        map[id] = true
        merged.push(item)
      })
      this.options = merged
    },
    loadSelected (value) {
      const id = this.normalizeId(value)
      if (!id || this.options.some(item => this.normalizeId(item.id) === id)) return
      getUser({
        currentPage: 1,
        pageSize: 20,
        accountIds: [id]
      }).then(res => {
        this.mergeOptions(this.normalizeRecords(res))
      })
    },
    loadOptions (keyword) {
      const seq = ++this.requestSeq
      this.loading = true
      getUser({
        currentPage: 1,
        pageSize: this.pageSize,
        keyword: keyword || ''
      }).then(res => {
        if (seq !== this.requestSeq) return
        this.options = this.normalizeRecords(res)
        this.loadSelected(this.value)
      }).finally(() => {
        if (seq === this.requestSeq) this.loading = false
      })
    },
    remoteSearch (keyword) {
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.loadOptions(keyword)
      }, 250)
    },
    handleVisibleChange (visible) {
      if (visible && this.options.length === 0) {
        this.loadOptions('')
      }
    },
    handleInput (value) {
      this.$emit('input', value || '')
    },
    handleChange (value) {
      const id = this.normalizeId(value)
      const selected = this.options.find(item => this.normalizeId(item.id) === id) || null
      this.$emit('change', selected)
    }
  }
}
</script>

<style>
.ai-account-select-dropdown .el-select-dropdown__item {
  height: 68px;
  line-height: normal;
  padding: 8px 20px;
}

.ai-account-select-dropdown .el-select-dropdown__item.selected {
  font-weight: normal;
}
</style>

<style scoped>
.account-option {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 100%;
  line-height: 18px;
}

.account-option__avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  overflow: hidden;
  border-radius: 50%;
  background: #f0f2f5;
  color: #909399;
  font-size: 16px;
}

.account-option__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.account-option__body {
  min-width: 0;
  flex: 1;
}

.account-option__main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.account-option__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-option__id,
.account-option__sub {
  color: #909399;
  font-size: 12px;
}

.account-option__sub {
  display: flex;
  gap: 12px;
}
</style>
